import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LottieDirectiveSharedModule } from '@shared/core/directives/lottie/lottie.directive.shared.module';

import { CartEmptyBlockComponent } from './cart-empty-block.shared.component';

@NgModule({
    declarations: [
        CartEmptyBlockComponent
    ],
    imports: [
        CommonModule,
        LottieDirectiveSharedModule,
    ],
    exports: [
        CartEmptyBlockComponent
    ],
    providers: [],
})
export class CartEmptyBlockModule { }
